'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function skipHello() {
}
function sayHello() {
}

exports.sayHello = sayHello;
exports.skipHello = skipHello;
//# sourceMappingURL=hello.js.map
